<template>
  <v-container fluid>
    <v-col class="mx-auto text-center">
      <h1 class="display-4">Oups !</h1>
      <h2 class="display-3">{{ $t("upgrade.titleError") }}</h2>
    </v-col>
    <v-col cols="12">
      <v-row>
        <v-col>
          <v-card class="orange lighten-2 white--text">
            <v-card-title>
              <h1>My</h1>
            </v-card-title>
            <v-card-text>
              <h4 class="text-center">
                My <br />19,00<span> € HT</span> / {{ $t("upgrade.month") }}
                <br /><small
                  ><font color="white"
                    >{{ $t("upgrade.userRate") }} <br />3
                    {{ $t("upgrade.monthMin") }}</font
                  ></small
                >
              </h4>
              <ul class="white--text">
                <li>
                  <i class="fa fa-check-circle-o"></i>1
                  {{ $t("upgrade.access") }}
                </li>
                <li>
                  <i class="fa fa-check-circle-o"></i>{{ $t("upgrade.city") }}
                </li>
                <li>
                  <i class="fa fa-check-circle-o"></i
                  >{{ $t("upgrade.forecasts") }}
                </li>
                <li>
                  <i class="fa fa-check-circle-o"></i
                  >{{ $t("upgrade.deadline") }}
                </li>
                <li>
                  <i class="fa fa-check-circle-o"></i>{{ $t("upgrade.maps") }}
                </li>
                <li>
                  <i class="fa fa-check-circle-o"></i>{{ $t("upgrade.alerts") }}
                </li>
                <li>
                  <i class="fa fa-check-circle-o"></i
                  >{{ $t("upgrade.alertsNow") }}
                </li>
                <li>
                  <i class="fa fa-check-circle-o"></i
                  >{{ $t("upgrade.bulletin") }}
                </li>
                <li>
                  <i class="fa fa-check-circle-o"></i>{{ $t("upgrade.radar") }}
                </li>
                <li>
                  <i class="fa fa-check-circle-o"></i
                  >{{ $t("upgrade.satellite") }}
                </li>
              </ul>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col>
          <v-card class="orange white--text">
            <v-card-title>
              <h1>My</h1>
            </v-card-title>
            <v-card-text>
              <h4 class="text-center">
                My <br />19,00<span> € HT</span> / {{ $t("upgrade.month") }}
                <br /><small
                  ><font color="white"
                    >Tarif par utilisateur <br />3
                    {{ $t("upgrade.monthMin") }}</font
                  ></small
                >
              </h4>
              <ul class="white--text">
                <li>
                  <i class="fa fa-check-circle-o"></i>1
                  {{ $t("upgrade.access") }}
                </li>
                <li>
                  <i class="fa fa-check-circle-o"></i>{{ $t("upgrade.city") }}
                </li>
                <li>
                  <i class="fa fa-check-circle-o"></i
                  >{{ $t("upgrade.forecasts") }}
                </li>
                <li>
                  <i class="fa fa-check-circle-o"></i
                  >{{ $t("upgrade.deadline") }}
                </li>
                <li>
                  <i class="fa fa-check-circle-o"></i>{{ $t("upgrade.maps") }}
                </li>
                <li>
                  <i class="fa fa-check-circle-o"></i>{{ $t("upgrade.alerts") }}
                </li>
                <li>
                  <i class="fa fa-check-circle-o"></i
                  >{{ $t("upgrade.alertsNow") }}
                </li>
                <li>
                  <i class="fa fa-check-circle-o"></i
                  >{{ $t("upgrade.bulletin") }}
                </li>
                <li>
                  <i class="fa fa-check-circle-o"></i>{{ $t("upgrade.radar") }}
                </li>
                <li>
                  <i class="fa fa-check-circle-o"></i
                  >{{ $t("upgrade.satellite") }}
                </li>
              </ul>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col>
          <v-card class="orange darken-2 white--text">
            <v-card-title>
              <h1>My</h1>
            </v-card-title>
            <v-card-text>
              <h4 class="text-center">
                My <br />19,00<span> € HT</span> / {{ $t("upgrade.month") }}
                <br /><small
                  ><font color="white"
                    >Tarif par utilisateur <br />3
                    {{ $t("upgrade.monthMin") }}</font
                  ></small
                >
              </h4>
              <ul class="white--text">
                <li>
                  <i class="fa fa-check-circle-o"></i>1
                  {{ $t("upgrade.access") }}
                </li>
                <li>
                  <i class="fa fa-check-circle-o"></i>{{ $t("upgrade.city") }}
                </li>
                <li>
                  <i class="fa fa-check-circle-o"></i
                  >{{ $t("upgrade.forecasts") }}
                </li>
                <li>
                  <i class="fa fa-check-circle-o"></i
                  >{{ $t("upgrade.deadline") }}
                </li>
                <li>
                  <i class="fa fa-check-circle-o"></i>{{ $t("upgrade.maps") }}
                </li>
                <li>
                  <i class="fa fa-check-circle-o"></i>{{ $t("upgrade.alerts") }}
                </li>
                <li>
                  <i class="fa fa-check-circle-o"></i
                  >{{ $t("upgrade.alertsNow") }}
                </li>
                <li>
                  <i class="fa fa-check-circle-o"></i
                  >{{ $t("upgrade.bulletin") }}
                </li>
                <li>
                  <i class="fa fa-check-circle-o"></i>{{ $t("upgrade.radar") }}
                </li>
                <li>
                  <i class="fa fa-check-circle-o"></i
                  >{{ $t("upgrade.satellite") }}
                </li>
              </ul>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-container>
</template>

<script>
export default {};
</script>

<style>
</style>